import styled from 'styled-components';
import { fontUi } from '../../../../../../theme/typography';

export const StyledPresets = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px solid ${({ theme }) => theme.borderSubtle};
`;

export const StyledPresetRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 0;
  & + & {
    border-top: 1px solid ${({ theme }) => theme.borderSubtle};
  }
`;

export const StyledPresetSaveRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledPresetCopy = styled.div`
  min-width: 0;
  flex: 1;
`;

export const StyledPresetName = styled.div`
  ${fontUi};
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledPresetMeta = styled.div`
  ${fontUi};
  margin-top: 2px;
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.textFaint};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledPresetActions = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
`;

export const StyledPresetButton = styled.button`
  ${fontUi};
  font-size: 11px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.hover};
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const StyledPresetIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: ${({ theme }) => theme.textFaint};
  cursor: pointer;
  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.danger || '#e94235'};
    background: ${({ theme }) => theme.hover};
  }
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const StyledPresetInput = styled.input`
  ${fontUi};
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.border};
  background: transparent;
  color: ${({ theme }) => theme.text};
  font-size: 12px;
`;

export const StyledPresetEmpty = styled.div`
  ${fontUi};
  font-size: 12px;
  color: ${({ theme }) => theme.textFaint};
  padding: 4px 0;
`;
